import { useEffect } from 'react';
import { focusElement } from '../../libs/dom-utils';
export function useFocusable(props, ref) {
    var autoFocus = props.autoFocus, disabled = props.disabled, tabIndex = props.tabIndex;
    useEffect(function () {
        if (autoFocus) {
            focusElement(ref.current);
        }
    }, [autoFocus, ref]);
    return {
        focusableProps: {
            tabIndex: disabled ? -1 : tabIndex,
        },
    };
}
